<header id="headadmin">
    <app-header></app-header>
    <app-navbar></app-navbar>
</header>
<body>
    <div class="card">
        <div class="card-header" style="background-color: #be0c4d;">
            <h5 style="color: white;">Novedad</h5>
        </div>
        <div class="row">
            <div class="col-2">
                <label>Tipo de novedad :</label>
            </div>
            <div class="col-3">
                <select class="form-select" aria-label="Default select example" name="tiponovedad" [(ngModel)]="NuevaNovedad.tipoNov" (change)="validarTipoNov($event.target.value)" [disabled]="btnGuardar">
                    <option  value="" selected="selected">Seleccione</option>
                    <option  value="1. Adquisición">1. Adquisición</option>
                    <option  value="2. Cesion de activos, pasivos y contratos">2. Cesion de activos, pasivos y contratoss</option>
                    <option  value="3. Constitución">3. Constitución</option>
                    <option  value="4. Conversión">4. Conversión</option>
                    <option  value="5. Disolución – Liquidación">5. Disolución – Liquidación</option>
                    <option  value="6. Disolución – Sin liquidación">6. Disolución – Sin liquidación</option>
                    <option  value="7. Escisión">7. Escisión</option>
                    <option  value="8. Fusión">8. Fusión</option>
                    <option  value="9. Liquidación Forzosa administrativa">9. Liquidación Forzosa administrativa</option>
                    <option  value="10. Liquidación voluntaria">10. Liquidación voluntaria</option>
                    <option  value="11. Toma de posesión Ley 510 de 1999">11. Toma de posesión Ley 510 de 1999</option>
                    <option  value="12. Transformación">12. Transformación</option>
                    <option  value="13. Cambio de tipo de entidad">13. Cambio de tipo de entidad</option>
                    <option  value="14. Certificado de No Movimiento">14. Certificado de No Movimiento</option>
                    <option  value="15. No Aplica">15. No Aplica</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <label>Fecha novedad :</label>
            </div>
            <div class="col-3">
                <input type="text" class="form-control" name="fechaActual" [(ngModel)]="fechaMostrar" disabled><!--(change)="mostar($event.target.value)"-->
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <label>Justificación :</label>
            </div>
            <div class="col-8">
                <textarea class="form-control" name="justificacion" rows="5" cols="5" maxlength="255" [(ngModel)]="NuevaNovedad.justNov" [disabled]="btnGuardar">Describa la justificación de la novedad</textarea><!--[formControl]="justificacionNov"-->
                <!--small *ngIf="justificacionNov.hasError('minLength')">*Justificación debe tener mas de 20 caracteres.</small-->
            </div>
        </div>
        <br>
        <div *ngIf="TipoFuente" class="d-grid gap-2 col-2 mx-auto">
            <button class="btn btn-secondary" (click)="GuardarNovedadChv()" [disabled]="btnGuardar">Guardar</button><!--(click)="guardarFuente()"-->
        </div>
        <div *ngIf="!TipoFuente" class="d-grid gap-2 col-2 mx-auto">
            <button class="btn btn-secondary" (click)="GuardarNovedadFivi()" [disabled]="btnGuardar">Guardar</button><!--(click)="guardarFuente()"-->
        </div>
        <br>
    </div>
</body>
